/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Aggiungi all’ordine",
  "i18n.additionalProducts.emotionalHook": "♥️ Molto amata:",
  "i18n.additionalProducts.productDescription": "Descrizione del prodotto",
  "i18n.additionalProducts.showMore": "Maggiori informazioni",
  "i18n.additionalProducts.title": "Accessori adatti",
  "i18n.button.addToCart": "Aggiungi al carrello",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Applica",
  "i18n.button.back": "Indietro",
  "i18n.button.cancel": "Elimina",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Chiudi",
  "i18n.button.continue": "Continua",
  "i18n.button.ignore": "Ignora",
  "i18n.button.ignoreAndContinue": "continua comunque",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Il testo",
  "i18n.button.noChanges": "senza SMART SORTED",
  "i18n.button.design": "",
  "i18n.button.photos": "Foto",
  "i18n.button.retry": "Riprova",
  "i18n.button.uploadPhotos": "Carica foto",
  "i18n.button.withSmartSorted": "Con SMART SORTED",
  "i18n.button.withoutSmartSorted": "Senza SMART SORTED",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.actionBar.duplicate": "",
  "i18n.control.actionBar.editText": "",
  "i18n.control.actionBar.leaveTextEditing": "",
  "i18n.control.actionBar.delete": "",
  "i18n.control.actionBar.rotate": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Per una migliore leggibilità, per favore inserire una linea di testo più corta.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Il carattere scelto è troppo grande per questo testo.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "E’ stato raggiunta la massima grandezza di carattere per questo testo.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "E’ stata raggiunta la grandezza minima di carattere per questo testo.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Inserisci l’interruzione di riga",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Continua a scrivere su una seconda riga o di ingrandire il campo riservato al testo.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Per favore controlla il tuo testo, questo font non supporta tutti i caratteri.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Per una migliore leggibilità, per favore inserisci una linea di testo più corta.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Ingrandisci il campo riservato al testo",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Questo passaggio non può essere annullato ",
  "i18n.dialog.deletePlaceholder.title": "Vuoi realmente eliminare questo segnaposto?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "La risoluzione di questa immagine è troppo bassa per una stampa ottimale della foto!",
  "i18n.dialog.smartSorted.message": "Con SMART SORTED è possibile comporre la propria immagine da 1000 pezzi in modo innovativo e senza sforzo, anche senza il motivo di riferimento.",
  "i18n.dialog.smartSorted.title": "Fai un puzzle con successo garantito",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Clicca su \"{{text}}\", per cambiare il titolo della scatola.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "il titolo della scatola non è stato cambiato",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continua senza il titolo della scatola",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Una variabile non è stata cambiata.",
    "Alcune variabili non sono state cambiate."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "variabili non modificate",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Hai interotto la realizzazione del tuo ordine per un periodo di tempo troppo lungo. Non è possibile continuare. Ti preghiamo di avviare nuovamente la procedura.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Una foto potrebbe non essere stata caricata.\nE’ stata rimossa dall’area di disegno e dalla galleria.",
  "i18n.error.imageLoadingError.title": "Errore nel download",
  "i18n.error.imageProvisionError.message": "Una o più foto potrebbero non essere state processate. Il formato file potrebbe non essere supportato.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "File \"{{reference1}}\" potrebbe non essere stato processato.",
  "i18n.error.imageSelectionError.title": "Errore durante il caricamento della foto",
  "i18n.error.imageSizeLimitExceededError.message": "L’immagine che hai caricato è troppo grande.\nTi preghiamo di ridurla a meno di 180 megapixel e di ricaricarla nuovamente.",
  "i18n.error.imageSizeLimitExceededError.title": "Errore durante il caricamento della foto",
  "i18n.error.imageUploadError.message": "Si è verificato un errore durante la connessione ad internet.\nSi prega di riprovare più tardi.",
  "i18n.error.imageUploadError.title": "Errore durante il caricamento della foto ",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Questo carattere non è utilizzabile, si prega di sceglierne un altro.",
  "i18n.error.invalidCharConfigError.title": "Carattere non è utilizzabile",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Sembra che la tua connessione ad internet si sia interrotta. Potrai continuare a progettare il tuo prodotto non appena la connessione sarà ristabilita.",
  "i18n.error.templateLoadingError.message": "Il modello \"{{ error.reference[0] }}\" non può essere caricato.\nTi preghiamo di riprovare più tardi.",
  "i18n.error.templateLoadingError.title": "Errore nel download ",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" hai un formato file non supportato.",
  "i18n.error.unsupportedMediaTypeError.title": "Errore durante il caricamento della foto ",
  "i18n.error.uploadProductError.message": "Uno o più prodotti non possono essere trasferiti al server.\nTi preghiamo di riprovare più tardi.",
  "i18n.error.uploadProductError.title": "Errore nel trasferimento",
  "i18n.error.zoomModeError.message": "Il testo della tua precedente configurazione non può essere utilizzato. Ti preghiamo di inserire un nuovo testo.",
  "i18n.error.zoomModeError.title": "Testo non adottato",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Prezzo",
  "i18n.price.reduction": "Risparmia",
  "i18n.price.total": "Prezzo totale",
  "i18n.priceDisplay.times": [
    "{{value}} pezzo a {{pricePerUnit}} cadauno",
    "{{value}} pezzi a {{pricePerUnit}} cadauno"
  ],
  "i18n.progress.stepAdditionalProducts": "Seleziona accessori",
  "i18n.progressOverlay.message.lines.one": "Grazie per la tua creazione.",
  "i18n.progressOverlay.message.lines.two": "Stiamo preparando il tuo prodotto...",
  "i18n.template.insertText": "Inserisci il testo qui",
  "i18n.toolbox.image.title": "Modifica foto",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 foto",
    "{{value}} foto"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "Anteprima 3D",
  "i18n.toolbox.productChooser.title": "Cambia prodotto",
  "i18n.toolbox.productChooser.triggerText": "Prodotto",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Modifica il testo",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleItIT {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
